export default "__VITE_ASSET__14854cf2__"